import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { LinkButton } from 'src/components';
import { SText } from 'src/components/SText';
import { StepText } from '../components/StepText';
import { eStoreAgencyInfoSelector } from '../store';

export const EStoreOnboarding = () => {
  const agencyInfo = useSelector(eStoreAgencyInfoSelector);
  const { url } = useRouteMatch();

  return (
    <div className="w-full">
      <div className="my-4">
        <SText
          label="estore-onboarding.intro"
          translatingOptions={{ agencyName: agencyInfo?.name }}
          classNames="text-xl"
        />
      </div>
      <div>
        <div>
          <SText label="estore-onboarding.sub-title" classNames="text-black text-lg block my-2" />

          <div>
            <StepText num="1" label="estore-onboarding.step-1" />
            <StepText
              num="2"
              label="estore-onboarding.step-2"
              translatingOptions={{
                agencyName: agencyInfo?.name,
                agencyAddress: agencyInfo?.address,
                zip: agencyInfo?.zip,
                city: agencyInfo?.city?.name,
                country: agencyInfo?.city?.country?.name,
              }}
            />
            <StepText
              num="3"
              label="estore-onboarding.step-3"
              translatingOptions={{ tel: agencyInfo?.telDemandesEstore }}
            />
          </div>
        </div>
        <div className="my-2 mb-1">
          <LinkButton label="estore-onboarding.button-start" to={`${url}/information`} extraClasses="block text-xl" />
        </div>
      </div>
    </div>
  );
};
